import * as types from './constants';

export const initialState = {
  listData: {
    campaign_modifiers: [],
    loading: false,
    count: 0,
    next: null,
    previous: null,
    curr_page: 1,
    errors_api: {},
    message: null
  }
};

const actions = {

  // Get Analytics Campaign Modifiers
  [types.GET_ANALYTICS_CAMPAIGN_MODIFIERS_REQUEST]: state => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: true
      }
    };

    return { ...data };
  },

  [types.GET_ANALYTICS_CAMPAIGN_MODIFIERS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: false,
        campaign_modifiers: payload.results,
        message: payload.message,
        count: payload.count,
        next: payload.next,
        previous: payload.next
      }
    };

    return { ...data };
  },

  [types.GET_ANALYTICS_CAMPAIGN_MODIFIERS_FAILED]: state => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: false
      }
    };

    return { ...data };
  },

  [types.GET_ANALYTICS_CAMPAIGN_MODIFIERS_RESET]: () => {
    return { ...initialState };
  },

  [types.ANALYTICS_CAMPAIGN_MODIFIERS_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      listData: {
        ...state.listData,
        curr_page: parseInt(payload) || 1
      }
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

